import classes from './AccordionSection.module.css';

const AccordionSection = ({ title, isOpen, onToggle, children }) => {
  return (
    <div className={classes.Section}>
      <button
        type="button"
        className={classes.Header}
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span>{title}</span>
        <span className={classes.Chevron} aria-hidden="true">
          {isOpen ? '▾' : '◂'}
        </span>
      </button>
      {isOpen ?
        <div className={classes.Body}>
          {children}
        </div>
        : null}
    </div>
  );
};

export default AccordionSection;
